import { useInterval } from '@solinkcorp/solink-components';
import { useEffect } from 'react';
import { useControllerState } from 'solox';
import { type PlaybackController } from './PlaybackController';

const DEFAULT_TICK_INTERVAL = 1000;
export const FFWD_AND_REWIND_TICK_INTERVAL = 100;

export function usePlaybackControllerTick(
  playbackController: PlaybackController,
  options?: {
    videoPlaybackEndsAtDate?: Date;
  },
) {
  const { videoPlaybackEndsAtDate } = options ?? {};
  const playerTime = useControllerState(playbackController.state, (state) => state.desiredTime);

  // Tick the playback controller at least once a second.
  // Rewinding requires it to be more frequent, because it is continually seeking to update the video frame
  // Fast forwarding doesn't require it, but it's nice to have the master time update more frequently
  useInterval(
    () => playbackController.tick(),
    playbackController.isRewinding() || playbackController.isFastForwarding()
      ? FFWD_AND_REWIND_TICK_INTERVAL
      : DEFAULT_TICK_INTERVAL,
  );

  /**
   * Pause the players when playerTime approaches videoPlaybackEndsAtDate
   * We can't check this condition within tick and pause the player since togglePaused calls tick (circular reference)
   */
  useEffect(() => {
    if (videoPlaybackEndsAtDate && playerTime >= videoPlaybackEndsAtDate.valueOf()) {
      playbackController.seekToTime(videoPlaybackEndsAtDate.valueOf());
      playbackController.togglePaused(true);
    }
  }, [playerTime, videoPlaybackEndsAtDate, playbackController]);
}
